import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';

export const RawAiHarmonySchema = z.record(z.string(), z.string());

export const GetAiHarmoniesResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(z.record(z.string(), RawAiHarmonySchema)),
});

export type RawAiHarmony = z.infer<typeof RawAiHarmonySchema>;

export type RawAiHarmonies = Record<string, RawAiHarmony>;

export type AiHarmony = {
  name: string;
  colors: { name: string; hex: string }[];
  selection: RawAiHarmony;
};

export const mapAiHarmonies = (harmonies: RawAiHarmonies): AiHarmony[] =>
  Object.entries(harmonies).map(([name, colors]) => ({
    name,
    colors: [1, 2, 3, 4]
      .map((i) => ({
        name: colors[`Harmony_Color_${i}_Name`] ?? '',
        hex: colors[`Harmony_Color_${i}_HEX`] ?? '',
      }))
      .filter((color) => color.hex),
    selection: colors,
  }));
